import { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Tooltip,
  IconButton,
} from "@mui/material";
import InfoOutlined from "@mui/icons-material/InfoOutlined";

import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

const TicketConfirmations = ({ config, update, org, configId }) => {
  const [ticketTerms, setTicketTerms] = useState("");
  const [webConfirm, setWebConfirm] = useState("");
  const [emailConfirm, setEmailConfirm] = useState("");

  useEffect(() => {
    if (config) {
      setTicketTerms(config?.defaultTicketTerms);
      setWebConfirm(config?.defaultWebConfirmation);
      setEmailConfirm(config?.defaultEmailConfirmation);
    }
  }, [config]);

  const handleSave = async (field, value) => {
    try {
      const body = { orgId: org, configId, config: { [field]: value } };
      const result = await request("orgs/updateconfig", "post", body);
      if (result.success) {
        toast.success("Configuration updated");
      } else {
        toast.error(result.error);
      }
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <Paper sx={{ p: 3, mt: 2 }} elevation={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Ticketing Configuration
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{ display: "flex", flexDirection: "column", height: "100%" }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <Typography variant="subtitle1" sx={{ mr: 1 }}>
                Ticket Purchase Terms & Conditions
              </Typography>
              <Tooltip title="The are the default ticket purchase terms & conditions the user will see during checkout. You can assign specific terms to the event by going to the event > Actions > Edit Event > Messaging">
                <IconButton size="small">
                  <InfoOutlined fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
            <TextField
              fullWidth
              multiline
              rows={10}
              value={ticketTerms}
              onChange={(e) => setTicketTerms(e.target.value)}
            />
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
              <Button
                variant="contained"
                onClick={() =>
                  handleSave("ticketing.defaultTicketTerms", ticketTerms)
                }
              >
                Save
              </Button>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{ display: "flex", flexDirection: "column", height: "100%" }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <Typography variant="subtitle1" sx={{ mr: 1 }}>
                Web Confirmation Message
              </Typography>
              <Tooltip title="What the user sees on the screen after they purchase a ticket. This customized for each event in the Edit Event dialog.">
                <IconButton size="small">
                  <InfoOutlined fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>

            <TextField
              fullWidth
              multiline
              rows={10}
              value={webConfirm}
              onChange={(e) => setWebConfirm(e.target.value)}
            />
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
              <Button
                variant="contained"
                onClick={() =>
                  handleSave("ticketing.defaultWebConfirmation", webConfirm)
                }
              >
                Save
              </Button>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{ display: "flex", flexDirection: "column", height: "100%" }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <Typography variant="subtitle1" sx={{ mr: 1 }}>
                Email Confirmation Message
              </Typography>
              <Tooltip title="The main body of the email that the user receives after they purchase a ticket. This is sent seperately from the receipt. This customized for each event in the Edit Event dialog.">
                <IconButton size="small">
                  <InfoOutlined fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>

            <TextField
              fullWidth
              multiline
              rows={10}
              value={emailConfirm}
              onChange={(e) => setEmailConfirm(e.target.value)}
            />
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
              <Button
                variant="contained"
                onClick={() =>
                  handleSave("ticketing.defaultEmailConfirmation", emailConfirm)
                }
              >
                Save
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default TicketConfirmations;
